import { queryOptions } from "@tanstack/react-query";
// import Cookies from "js-cookie";

import {
  fetchAllAttendanceRequestsForAdmin,
  fetchAllLeads,
  fetchAllPerformanceLogsOfEmployeeForAdmin,
  fetchAllPerformanceReportOfEmployeeForAdmin,
  fetchAllSalaryOfEmployeeForAdmin,
  fetchAllTimesheetsByMonthForAdmin,
  fetchSingleEmployee,
  fetchSingleLeadLogForAdmin,
  fetchSingleTimesheetByIdForAdmin,
  getAllAllowanceRequests,
  getAllAnnouncementsForAdmin,
  getAllEmployees,
  getAllHolidayList,
  getAllLeaveApplications,
  getAllLoanRequestsForAdmin,
  getAllLoanRequestsOfEmpByAdmin,
  getAllLoansOfEmployeeByAdmin,
  getAttendanceOfAllEmployees,
  getAttendanceOfEmployeeForAdmin,
  getAttendanceRequestsOfEmpByAdmin,
  getBreaksOfEmployeesDayWise,
  getCheckinsOfEmployeesDayWise,
  getCurrentAdmin,
  getEmployeeBreaks,
  getEmployeeCheckins,
  getLoanRepaymentRequestsForAdmin,
  getOneHolidayList,
  getSingleLoanRequest,
} from "@/config/queries/admin/admin-queries";
import {
  getAllCompanyHolidayLists,
  getOneCompanyHolidayList,
  getActiveCompanyHolidayListAdmin,
} from "@/config/queries/company-holiday-queries";
import { getAllTodosForAdmin, getOneTodoForAdmin } from "./admin/todo-queries";
import { fetchAllPerformanceReportsForEmployeeByAdmin } from "./admin/admin-performance-queries";

// const ADMIN_KEY = Cookies.get("key") as string;

// || *********************** QUERY OPTIONS ******************** ||

export const getAllEmployeesQueryOptions = (adminKey: string) =>
  queryOptions({
    queryKey: ["employees"],
    queryFn: () => getAllEmployees(adminKey),
    refetchOnWindowFocus: false,
  });

export const getCurrentAdminQueryOptions = (adminKey: string) =>
  queryOptions({
    queryKey: ["admin"],
    queryFn: () => getCurrentAdmin(adminKey),
    refetchOnWindowFocus: false,
    enabled: !!adminKey,
  });

export const getSingleEmployeeQueryOptions = (
  adminKey: string,
  empId: string
) =>
  queryOptions({
    queryKey: ["employee", empId],
    queryFn: () => fetchSingleEmployee(adminKey)(empId),
    enabled: empId !== "",
    refetchOnWindowFocus: false,
  });

export const getAttendanceOfEmployeeForAdminQueryOptions = (
  adminKey: string,
  startdate: Date,
  enddate: Date,
  employee: string
) =>
  queryOptions({
    queryKey: ["empoyee-attendace", startdate, enddate, employee],
    queryFn: () =>
      getAttendanceOfEmployeeForAdmin(adminKey)({
        startdate,
        enddate,
        employee,
      }),
    refetchOnWindowFocus: false,

    // refetchInterval: 300000,
  });

export const getAttendanceOfAllEmployeesForAdminQueryOptions = (
  adminKey: string,
  startdate: Date,
  enddate: Date
) =>
  queryOptions({
    queryKey: ["empoyee-attendaces", startdate, enddate],
    queryFn: () =>
      getAttendanceOfAllEmployees(adminKey)({
        startdate,
        enddate,
      }),
    refetchOnWindowFocus: false,

    // refetchInterval: 300000,
  });

export const getAllHolidayListQueryOptions = (adminKey: string) =>
  queryOptions({
    queryKey: ["holidays"],
    queryFn: () => getAllHolidayList(adminKey),
    refetchOnWindowFocus: false,
  });

export const getOneHolidayListQueryOptions = (
  adminKey: string,
  holidayListId: string
) =>
  queryOptions({
    queryKey: ["holiday", holidayListId],
    queryFn: () => getOneHolidayList(adminKey)(holidayListId),
    refetchOnWindowFocus: false,
  });

export const getEmployeeCheckinsQueryOptions = (
  adminKey: string,
  empId: string
) =>
  queryOptions({
    queryKey: ["checkins", empId],
    queryFn: () => getEmployeeCheckins(adminKey)(empId),
    refetchOnWindowFocus: false,
    enabled: empId !== "",
  });

export const getAllLeaveApplicationQueryOptions = (
  adminKey: string,
  status: string
) =>
  queryOptions({
    queryKey: ["leave-applications", status],
    queryFn: () => getAllLeaveApplications(adminKey)(status),
    refetchOnWindowFocus: false,
    enabled: status !== "",

    // refetchInterval: 10000,
  });

export const getAllSalaryOfEmployeeQueryOptions = (
  adminKey: string,
  period: {
    start: Date;
    end: Date;
  }
) =>
  queryOptions({
    queryKey: ["employees-salary", period],
    queryFn: () => fetchAllSalaryOfEmployeeForAdmin(adminKey)(period),
    refetchOnWindowFocus: false,
  });

export const getAllEmployeesCheckinsDayWiseQueryOptions = (
  adminKey: string,
  day: Date
) =>
  queryOptions({
    queryKey: ["all-employees-checkins", day],
    queryFn: () =>
      getCheckinsOfEmployeesDayWise(adminKey)({
        date: day,
      }),
    refetchOnWindowFocus: false,
  });

export const fetchAllLeadsForAdminQueryOptions = (
  adminKey: string,
  data: {
    startdate: Date;
    enddate: Date;
    status?: string;
  }
) =>
  queryOptions({
    queryKey: ["leads", "admin", data],
    queryFn: () => fetchAllLeads(adminKey)(data),
    refetchOnWindowFocus: false,
    retry: 2,
  });

export const getAllAllowanceRequestsQueryOptions = (
  adminKey: string,
  status: string
) =>
  queryOptions({
    queryKey: ["allowances", status],
    queryFn: () => getAllAllowanceRequests(adminKey)(status),
    refetchOnWindowFocus: false,
    enabled: status !== "",
    // refetchInterval: 20000,
  });

export const getAllLoanRequestsQueryOptions = (
  adminKey: string,
  status: string
) =>
  queryOptions({
    queryKey: ["loans", status],
    queryFn: () => getAllLoanRequestsForAdmin(adminKey)(status),
    refetchOnWindowFocus: false,
    enabled: status !== "",
    // refetchInterval: 20000,
  });

export const getAllLoanRequestsOfEmpByAdminQueryOptions = (
  adminKey: string,
  status?: string
) =>
  queryOptions({
    queryKey: ["other-loans", status],
    queryFn: () => getAllLoanRequestsOfEmpByAdmin(adminKey)(status),
    refetchOnWindowFocus: false,
    // enabled: status !== "",
  });

export const getOneLoanRequestQueryOptions = (
  adminKey: string,
  loanId: string
) =>
  queryOptions({
    queryKey: ["other-loan", loanId],
    queryFn: () => getSingleLoanRequest(adminKey)(loanId),
    refetchOnWindowFocus: false,
    // refetchInterval: 20000,
  });

export const getLoanRepaymentRequestsForAdminQueryOptions = (
  employeeKey: string,
  loanId: string
) =>
  queryOptions({
    queryKey: ["admin-repayment-requests", loanId],
    queryFn: () => getLoanRepaymentRequestsForAdmin(employeeKey)(loanId),
    refetchOnWindowFocus: false,
    // refetchInterval: 20000,
  });

export const getOneLeadLogsQueryOptions = (adminKey: string, leadId: string) =>
  queryOptions({
    queryKey: ["lead-logs", leadId],
    queryFn: () => fetchSingleLeadLogForAdmin(adminKey)(leadId),
    refetchOnWindowFocus: false,
    enabled: !!leadId,
  });

export const fetchAllAttendanceRequestForAdminQueryOptions = (
  adminKey: string,
  data: {
    startdate: Date;
    enddate: Date;
    status?: string;
  }
) =>
  queryOptions({
    queryKey: ["attendance-requests", data],
    queryFn: () => fetchAllAttendanceRequestsForAdmin(adminKey)(data),
    refetchOnWindowFocus: false,
    retry: 2,
    // refetchInterval: 20000,
  });

export const fetchAllPerformanceLogsOfEmployeeForAdminQueryOptions = (
  adminKey: string,
  data: {
    startdate: Date;
    enddate: Date;
    employee: string;
  }
) =>
  queryOptions({
    queryKey: ["performance-logs", data],
    queryFn: () => fetchAllPerformanceLogsOfEmployeeForAdmin(adminKey)(data),
    refetchOnWindowFocus: false,
    retry: 2,
    // refetchInterval: 20000,
  });

export const fetchAllTimesheetsByMonthForAdminQueryOptions = (
  adminKey: string,
  data: {
    monthName: string;
    year: number;
  }
) =>
  queryOptions({
    queryKey: ["timesheets-month", data],
    queryFn: () => fetchAllTimesheetsByMonthForAdmin(adminKey)(data),
    refetchOnWindowFocus: false,
    retry: 2,
  });

export const fetchSingleTimesheetByIdForAdminQueryOptions = (
  adminKey: string,
  sheetId: string
) =>
  queryOptions({
    queryKey: ["timesheet-month", sheetId],
    queryFn: () => fetchSingleTimesheetByIdForAdmin(adminKey)(sheetId),
    refetchOnWindowFocus: false,
    retry: 2,
    enabled: sheetId !== "" || sheetId !== null,
  });

export const fetchAllPerformanceReportOfEmployeeForAdminQueryOptions = (
  adminKey: string,
  data: {
    startdate: Date;
    enddate: Date;
    employee: string;
    published: boolean;
  }
) =>
  queryOptions({
    queryKey: ["performance-report", data],
    queryFn: () => fetchAllPerformanceReportOfEmployeeForAdmin(adminKey)(data),
    refetchOnWindowFocus: false,
    retry: 2,
    refetchInterval: 20000,
  });

export const getAllAnnouncementsForAdminQueryOptions = (
  employeeKey: string,
  startdate: Date,
  enddate: Date
) =>
  queryOptions({
    queryKey: ["admin-announcements", startdate, enddate],
    queryFn: () =>
      getAllAnnouncementsForAdmin(employeeKey)({
        startdate,
        enddate,
      }),
    refetchOnWindowFocus: false,

    // refetchInterval: 300000,
  });

// ! TODOS QUERY OPTIONS ! //
export const getAllTodosQueryOptions = (
  adminKey: string,
  startdate: Date,
  enddate: Date,
  empId?: string
) =>
  queryOptions({
    queryKey: ["todos", startdate, enddate, empId],
    queryFn: () =>
      getAllTodosForAdmin(adminKey)({
        startdate,
        enddate,
      }),
    refetchOnWindowFocus: true,

    // refetchInterval: 2000,
  });

export const getOneTodoQueryOptions = (adminKey: string, todoId: string) =>
  queryOptions({
    queryKey: ["todo", todoId],
    queryFn: () => getOneTodoForAdmin(adminKey)(todoId),
    refetchOnWindowFocus: false,

    refetchInterval: 10000,
  });

export const getAllLoanOfEmployeeByAdminQueryOptions = (
  adminKey: string,
  need: {
    status: string;
    employee: string;
  }
) =>
  queryOptions({
    queryKey: ["single-emp-loans", need],
    queryFn: () => getAllLoansOfEmployeeByAdmin(adminKey)(need),
    refetchOnWindowFocus: false,
    enabled: need.employee !== "",
  });

export const getAllAttendanceRequestOfEmployeeByAdminQueryOptions = (
  adminKey: string,
  need: {
    status: string;
    employee: string;
  }
) =>
  queryOptions({
    queryKey: ["single-emp-att-requests", need],
    queryFn: () => getAttendanceRequestsOfEmpByAdmin(adminKey)(need),
    refetchOnWindowFocus: false,
    enabled: need.employee !== "",
  });

export const getAllPerformanceReportsForEmployeeQueryOptions = (
  adminKey: string,
  need: {
    month?: string;
    employee: string;
    year: number;
  }
) =>
  queryOptions({
    queryKey: ["performance-reports", need],
    queryFn: () => fetchAllPerformanceReportsForEmployeeByAdmin(adminKey)(need),
    refetchOnWindowFocus: false,
    enabled: need.employee !== "",
  });

// ! COMPANY HOLIDAYS QUERY OPTIONS ! //
export const getAllCompanyHolidayListsQueryOptions = (adminKey: string) =>
  queryOptions({
    queryKey: ["company-holidays"],
    queryFn: () => getAllCompanyHolidayLists(adminKey),
    refetchOnWindowFocus: false,
  });

export const getOneCompanyHolidayListQueryOptions = (
  adminKey: string,
  id: string
) =>
  queryOptions({
    queryKey: ["company-holiday", id],
    queryFn: () => getOneCompanyHolidayList(adminKey)(id),
    refetchOnWindowFocus: false,
    enabled: id !== "",
  });

export const getActiveCompanyHolidayListQueryOptions = (
  adminKey: string,
  year?: number
) =>
  queryOptions({
    queryKey: ["company-holiday-active", year],
    queryFn: () => getActiveCompanyHolidayListAdmin(adminKey)(year),
    refetchOnWindowFocus: false,
  });

export const getAllEmployeesBreaksDayWiseQueryOptions = (adminKey: string, day: Date) =>
  queryOptions({
    queryKey: ["all-employees-breaks", day],
    queryFn: () => getBreaksOfEmployeesDayWise(adminKey)({ date: day }),
    refetchOnWindowFocus: false,
  });

export const getEmployeeBreaksQueryOptions = (adminKey: string, empId: string) =>
  queryOptions({
    queryKey: ["breaks", empId],
    queryFn: () => getEmployeeBreaks(adminKey)(empId),
    refetchOnWindowFocus: false,
    enabled: empId !== "",
  });
